import { z as z$1 } from "zod";

// src/models/vendors/bridge/mappedNote.ts
/** v1 Bridge Note `data` keys mapped from Canvas extract. */
const BRIDGE_MAPPED_NOTE_FIELD_ICD10 = "ICD10";
const BRIDGE_MAPPED_NOTE_FIELD_ASSESSMENT = "ASSESSMENT";
const BRIDGE_MAPPED_NOTE_FIELD_TIME_SPENT_MINUTES = "TIME_SPENT_MINUTES";
const BRIDGE_MAPPED_NOTE_FIELD_SUBJECTIVE = "SUBJECTIVE";
const BRIDGE_MAPPED_NOTE_FIELD_OBJECTIVE = "OBJECTIVE";
const BRIDGE_MAPPED_NOTE_FIELD_PLAN = "PLAN";
const BRIDGE_MAPPED_NOTE_FIELD_HEIGHT = "HEIGHT";
const BRIDGE_MAPPED_NOTE_FIELD_WEIGHT = "WEIGHT";
const BRIDGE_MAPPED_NOTE_FIELD_MEDICATIONS = "MEDICATIONS";
const BRIDGE_MAPPED_NOTE_FIELD_DIAGNOSIS = "DIAGNOSIS";
const BRIDGE_MAPPED_NOTE_FIELD_TELEHEALTH_DISCLAIMER = "TELEHEALTH_DISCLAIMER";
const bridgeMappedNoteFieldKeySchema = z$1.enum([
	BRIDGE_MAPPED_NOTE_FIELD_ICD10,
	BRIDGE_MAPPED_NOTE_FIELD_ASSESSMENT,
	BRIDGE_MAPPED_NOTE_FIELD_TIME_SPENT_MINUTES,
	BRIDGE_MAPPED_NOTE_FIELD_SUBJECTIVE,
	BRIDGE_MAPPED_NOTE_FIELD_OBJECTIVE,
	BRIDGE_MAPPED_NOTE_FIELD_PLAN,
	BRIDGE_MAPPED_NOTE_FIELD_HEIGHT,
	BRIDGE_MAPPED_NOTE_FIELD_WEIGHT,
	BRIDGE_MAPPED_NOTE_FIELD_MEDICATIONS,
	BRIDGE_MAPPED_NOTE_FIELD_DIAGNOSIS,
	BRIDGE_MAPPED_NOTE_FIELD_TELEHEALTH_DISCLAIMER
]);
const bridgeMappedNoteDataSchema = z$1.object({
	[BRIDGE_MAPPED_NOTE_FIELD_ICD10]: z$1.array(z$1.string()).optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_ASSESSMENT]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_TIME_SPENT_MINUTES]: z$1.number().int().positive().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_SUBJECTIVE]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_OBJECTIVE]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_PLAN]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_HEIGHT]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_WEIGHT]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_MEDICATIONS]: z$1.array(z$1.string()).optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_DIAGNOSIS]: z$1.string().optional(),
	[BRIDGE_MAPPED_NOTE_FIELD_TELEHEALTH_DISCLAIMER]: z$1.string().optional()
});
const bridgeMappedNoteActionSchema = z$1.enum([
	"create",
	"addendum",
	"unchanged",
	"incomplete"
]);
const bridgeMappedNoteEvaluationSchema = z$1.object({
	ready: z$1.boolean(),
	missingFields: z$1.array(bridgeMappedNoteFieldKeySchema),
	payloadHash: z$1.string().min(1),
	action: bridgeMappedNoteActionSchema,
	data: bridgeMappedNoteDataSchema
});

export { BRIDGE_MAPPED_NOTE_FIELD_ASSESSMENT, BRIDGE_MAPPED_NOTE_FIELD_DIAGNOSIS, BRIDGE_MAPPED_NOTE_FIELD_HEIGHT, BRIDGE_MAPPED_NOTE_FIELD_ICD10, BRIDGE_MAPPED_NOTE_FIELD_MEDICATIONS, BRIDGE_MAPPED_NOTE_FIELD_OBJECTIVE, BRIDGE_MAPPED_NOTE_FIELD_PLAN, BRIDGE_MAPPED_NOTE_FIELD_SUBJECTIVE, BRIDGE_MAPPED_NOTE_FIELD_TELEHEALTH_DISCLAIMER, BRIDGE_MAPPED_NOTE_FIELD_TIME_SPENT_MINUTES, BRIDGE_MAPPED_NOTE_FIELD_WEIGHT, bridgeMappedNoteActionSchema, bridgeMappedNoteDataSchema, bridgeMappedNoteEvaluationSchema, bridgeMappedNoteFieldKeySchema };
//# sourceMappingURL=mappedNote.mjs.map